import { useCallback, useContext, useEffect, useRef } from "react";
import { v4 as uuid } from "uuid";
import { ModalCtx } from "./ModalProvider";

const obj = {};
export const useModal = (modal = obj) => {
  const id = useRef(uuid());
  const { updateItem, destroyItem } = useContext(ModalCtx);

  useEffect(() => {
    const withId = { ...modal, id: id.current };
    updateItem(withId);
  }, [modal, updateItem]);

  useEffect(
    () => () => {
      destroyItem({ id: id.current });
    },
    [destroyItem],
  );

  return {
    show: useCallback(
      () => updateItem({ id: id.current, open: true }),
      [updateItem],
    ),
  };
};
